import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Portfolio/tabsConfig";
const I18n = I18nUtil.createScoped(Translations);
export type PortfolioTabId = "market" | "report" | "news";

export interface PortfolioTabMeta {
  id: PortfolioTabId;
  label: string;
}

export const getPortfolioTabs = (): PortfolioTabMeta[] => {
  const tabs = [
    { id: "market", label: I18n.t("Market") },
    { id: "report", label: I18n.t("360° Report") },
    { id: "news", label: I18n.t("News") },
  ];
  return tabs as PortfolioTabMeta[];
};
